import { cn } from '@/shared/lib/cn';

type WordmarkProps = { size?: 'md' | 'lg'; className?: string };

export function Wordmark({ size = 'md', className }: WordmarkProps) {
  return (
    <span
      data-slot="wordmark"
      className={cn(
        'font-semibold',
        size === 'lg' ? 'text-wordmark-lg' : 'text-wordmark',
        className,
      )}
    >
      macswarm
    </span>
  );
}
